<div class="p-grid">
	<div class="p-col-12 p-lg-6 d-flex flex-column">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">Kiosk Settings</div>
		</div>
		<p-divider></p-divider>
		<div class="d-flex w-100 mt-2">
			Guest identification type
			<div class="ms-auto">
				<p-dropdown
					#identificationTypeSelect
					[options]="identificationType"
					optionLabel="label"
					optionValue="value"
					name="identificationTypeSelect"
					[(ngModel)]="orderType.identifierInputType"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(identificationType)"
					(onChange)="changesToSaveChange.emit(true)"
				></p-dropdown>
			</div>
		</div>
		<div class="d-flex w-100 mt-2">
			Guest identifier
			<div class="ms-auto">
				<input
					[disabled]="orderType.identifierInputType === 2"
					pInputText
					#idValue
					name="idValue"
					type="text"
					[(ngModel)]="orderType.identifierName"
					class="w-100"
					(change)="changesToSaveChange.emit(true)"
				/>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-lg-6 d-flex flex-column"></div>
	<div class="p-col-12 p-lg-6 d-flex flex-column"></div>
	<div class="p-col-12 p-lg-6 d-flex flex-column"></div>
</div>
<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="orderType.identifierNameOptions"
	[loading]="!orderType.identifierNameOptions"
	[globalFilterFields]="app.keys(orderType.identifierNameOptions)"
	[scrollable]="true"
	[rows]="100"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1 me-2">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
			<div class="ms-auto">
				<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="onAdd()">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
							Add Order Identifier
						</div>
					</ng-template>
				</p-button>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th>Name</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr>
			<td>{{ rec }}</td>
		</tr>
	</ng-template>
</p-table>

<p-dialog *ngIf="identifierSelected" [(visible)]="identifierSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<fa-icon [icon]="['far', 'plus']" class="me-4" size="lg"></fa-icon>
		Order Idenfitier
	</ng-template>

	<span class="p-float-label mt-4">
		<input pInputText #identifierName name="identifierName" type="text" [(ngModel)]="identifierSelected.name" class="w-100" />
		<label for="identifierName">Order Identifier Name</label>
	</span>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]=""
			[hideSave]=""
			(onCancelChange)="identifierSelected = undefined"
			(onDeleteChange)="onDelete(identifierSelected)"
			(onSaveChange)="onSave(identifierSelected)"
			[cancelDisabled]=""
			[deleteDisabled]="identifierSelected.unsaved"
			[saveDisabled]="!identifierSelected.name"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
